module.exports = __webpack_public_path__ + "static/img/9.6fb8563.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/sp/9.png
// module id = zW0k
// module chunks = 0